export const snackbarStoreKey = 'snackbar';
